import { FpjsClient } from '@fingerprintjs/fingerprintjs-pro-spa';

const fpjsClient = new FpjsClient({
  loadOptions: {
    apiKey: process.env.VUE_APP_FINGERPRINT_PK,
    ...(process.env.VUE_APP_FINGERPRINT_DOMAIN && {
      endpoint: `https://${process.env.VUE_APP_FINGERPRINT_DOMAIN}`,
      scriptUrlPattern: `https://${process.env.VUE_APP_FINGERPRINT_DOMAIN}/web/v<version>/<apiKey>/loader_v<loaderVersion>.js`,
    }),
  },
  cacheLocation: 'localstorage',
});

const visitorDataPromise = fpjsClient.init().then(() => {
  return fpjsClient.getVisitorData();
});

let extendedVisitorData = null;
const getExtendedVisitorData = () => {
  if (extendedVisitorData) {
    return extendedVisitorData;
  }
  return fpjsClient.init().then(() => {
    extendedVisitorData = fpjsClient.getVisitorData({ extendedResult: true });
    return extendedVisitorData;
  });
};

export { visitorDataPromise, getExtendedVisitorData };
